export default "__VITE_ASSET__GfWPqqFn__"